/* Glowtrendy — scripts propios (prefijo gt-) */
(function () {
  if (window.__gtLoaded) return;
  window.__gtLoaded = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.gt-reveal:not(.gt-visible), .gt-img-reveal:not(.gt-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('gt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('gt-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCountUp(root) {
    var els = (root || document).querySelectorAll('[data-gt-count]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target, end = parseFloat(el.getAttribute('data-gt-count')) || 0;
        var suffix = el.getAttribute('data-gt-suffix') || '';
        if (reduce) { el.textContent = end + suffix; return; }
        var start = performance.now(), dur = 1600;
        (function tick(now) {
          var p = Math.min((now - start) / dur, 1), eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(end * eased) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        })(start);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var els = document.querySelectorAll('[data-gt-parallax]');
    if (!els.length || reduce) return;
    var ticking = false;
    function update() {
      els.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        var k = parseFloat(el.getAttribute('data-gt-parallax')) || 0;
        var offset = (r.top + r.height / 2 - window.innerHeight / 2) * -k / 100;
        el.style.translate = '0 ' + offset.toFixed(1) + 'px';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initProduct(root) {
    var pdps = (root || document).querySelectorAll('[data-gt-pdp]');
    pdps.forEach(function (pdp) {
      if (pdp.dataset.gtReady) return;
      pdp.dataset.gtReady = '1';

      // Galería
      var main = pdp.querySelector('[data-gt-main]');
      var thumbs = pdp.querySelectorAll('[data-gt-thumb]');
      function show(src, srcset) {
        if (!main) return;
        main.src = src;
        if (srcset) main.srcset = srcset;
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-src') === src); });
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { show(t.getAttribute('data-src'), t.getAttribute('data-srcset')); });
      });

      // Cantidad
      var qty = pdp.querySelector('[data-gt-qty]');
      pdp.querySelectorAll('[data-gt-qty-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value, 10) || 1;
          qty.value = Math.max(1, v + parseInt(b.getAttribute('data-gt-qty-step'), 10));
        });
      });

      // Variantes
      var dataEl = pdp.querySelector('[data-gt-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var idInput = pdp.querySelector('[data-gt-id]');
      var priceEl = pdp.querySelector('[data-gt-price]');
      var compareEl = pdp.querySelector('[data-gt-compare]');
      var saveEl = pdp.querySelector('[data-gt-save]');
      var buttons = document.querySelectorAll('[data-gt-add]');
      var labels = { add: pdp.getAttribute('data-label-add'), sold: pdp.getAttribute('data-label-sold') };
      var moneyFormat = pdp.getAttribute('data-money-format') || '${{amount}}';

      function money(cents) {
        var amount = (cents / 100).toFixed(2);
        var noDec = Math.round(cents / 100).toString();
        var comma = amount.replace('.', ',');
        return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
          if (k === 'amount_no_decimals') return noDec;
          if (k === 'amount_with_comma_separator') return comma;
          return amount;
        });
      }

      function current() {
        var selected = [];
        pdp.querySelectorAll('[data-gt-option]').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          selected.push(c ? c.value : null);
        });
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === selected[i]; });
        });
      }

      pdp.addEventListener('change', function (e) {
        if (!e.target.closest('[data-gt-option]')) return;
        var v = current();
        buttons.forEach(function (b) {
          b.disabled = !v || !v.available;
          var l = b.querySelector('[data-gt-label]') || b;
          l.textContent = v && v.available ? labels.add : labels.sold;
        });
        if (!v) return;
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (compareEl) { compareEl.textContent = onSale ? money(v.compare_at_price) : ''; compareEl.hidden = !onSale; }
        if (saveEl) {
          saveEl.hidden = !onSale;
          if (onSale) saveEl.textContent = saveEl.getAttribute('data-prefix') + ' ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
        }
        if (v.featured_image && pdp.getAttribute('data-follow-variant') === 'true') show(v.featured_image.src.replace(/^https?:/, ''));
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(null, '', url.toString());
      });
    });

    // Barra fija de compra en móvil
    var sticky = document.querySelector('[data-gt-sticky]');
    var form = document.querySelector('[data-gt-form]');
    if (sticky && form && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }).observe(form);
      var btn = sticky.querySelector('button');
      if (btn) btn.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
    }
  }

  function initSplit(root) {
    (root || document).querySelectorAll('[data-gt-split]:not([data-gt-done])').forEach(function (el) {
      el.setAttribute('data-gt-done', '1');
      var i = 0;
      function wrap(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            var frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function (w) {
              if (!w) return;
              if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(w)); return; }
              var o = document.createElement('span'); o.className = 'gt-word';
              var s = document.createElement('span'); s.style.setProperty('--i', i++); s.textContent = w;
              o.appendChild(s); frag.appendChild(o);
            });
            n.parentNode.replaceChild(frag, n);
          } else if (n.nodeType === 1) { wrap(n); }
        });
      }
      wrap(el);
      el.classList.add('gt-reveal');
    });
  }

  function initTilt(root) {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    (root || document).querySelectorAll('.gt-tilt').forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--ry', ((e.clientX - r.left) / r.width - .5) * 6 + 'deg');
        el.style.setProperty('--rx', (.5 - (e.clientY - r.top) / r.height) * 6 + 'deg');
      });
      el.addEventListener('mouseleave', function () { el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg'); });
    });
  }

  function initMagnetic(root) {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    (root || document).querySelectorAll('.gt-btn--magnetic').forEach(function (b) {
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.transform = 'translate(' + (e.clientX - r.left - r.width / 2) * .15 + 'px,' + (e.clientY - r.top - r.height / 2) * .25 + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }

  function initAll(root) { initSplit(root); initTilt(root); initMagnetic(root); initReveal(root); initCountUp(root); initProduct(root); }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); initParallax(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
